<template>
  <div class="container-fluid">
    <div class="chart-page">
      <div class="card mb-2">
        <div class="card-body" style="text-align: -webkit-center">
          <div class="chart-title mb-4">黑名單報表</div>
          <apexchart
            width="500"
            height="350"
            type="bar"
            :options="chartOptions"
            :series="chartSeries"
          />
          <div class="col-sm-12 col-md-4">
            <div class="form-group">
              <label for="" class="mr-2">年份</label>
              <ValidationProvider required v-slot="{ errors }">
                <el-date-picker
                  class="w-50"
                  type="year"
                  :clearable="false"
                  :picker-options="pickerOptions"
                  v-model="year"
                />
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">月份</label>
                <ValidationProvider required v-slot="{ errors }">
                  <el-date-picker
                    class="w-100"
                    type="monthrange"
                    :clearable="false"
                    :picker-options="pickerOptions"
                    v-model="monthRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-sm-12 col-md-4">
              <button
                type="button"
                class="btn btn-primary"
                style="margin-top: 30px; margin-left: 10px"
                @click="tableInfo.page = 1; getBlacklistDetail()"
              >
                查詢
              </button>
              <button
                type="button"
                class="btn btn-info"
                style="margin-top: 30px; margin-left: 10px"
                @click="handleSubmit(exportBlacklist)"
              >
                匯出報表
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column label="姓名">
          <template slot-scope="props">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="showDetailModal(props.row)"
            >
              {{ props.row.Name }}
            </button>
          </template>
        </el-table-column>
        <el-table-column prop="IdNo" label="身分證字號/護照號碼" />
        <el-table-column prop="Reason" label="原因" />
        <el-table-column prop="CreateUser" label="標記者" />
        <el-table-column label="標記時間">
          <template slot-scope="props">
            <span>{{ $common.dateFormatter(props.row.CreateTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="props">
            <el-popconfirm
              title="確認刪除？"
              confirm-button-text="確認"
              cancel-button-text="取消"
              @confirm="blacklistRemoval(props.row.ResumeId)"
            >
              <el-button type="danger" size="mini" slot="reference">
                刪除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalData"
        :page-size="10"
        :current-page.sync="tableInfo.page"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="(detailCurrentPage = 0), (ResumeType = 'IDL')">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                IDL 履歷
              </span>
            </a>
            <a @click.prevent="(detailCurrentPage = 0), (ResumeType = 'DL')">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                DL 履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <div class="item text-center">履歷</div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "BlackList",

  components: {
    IdlResume,
    DlResume,
  },
  data() {
    return {
      // 查詢年份
      year: null,
      // 查詢月份
      monthRange: [],

      // table data
      tableData: [],
      totalData: 0,
      // 分頁資訊
      tableInfo: {
        page: 1,
        perPage: 10,
      },

      ResumeType: "IDL",
      ResumeId: null,
      isShowDetail: false,
      detailCurrentPage: 0,

      // 長條圖 data
      seriesData: [],

      chartOptions: {
        xaxis: {
          categories: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 10,
        },
      },

      // 顯示的月份
      monthList: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
      ],
      // 卡控不能選擇未來時間
      pickerOptions: {
        disabledDate: (date) => {
          let currentDay = this.dayjs();
          return (
            this.dayjs(date) > currentDay
          );
        },
      },
    };
  },

  methods: {
    // 解除 黑名單
    blacklistRemoval(person) {
      this.updateLoading(true);
      this.$api.talentPool.removeBlacklist([person]).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "已解除黑名單",
            type: "success",
            duration: 2500,
          });
          this.getBlacklistDetail();
        }
        this.updateLoading(false);
      });
    },

    // 黑名單 詳細資料
    getBlacklistDetail() {
      this.updateLoading(true);
      this.$api.blacklist
        .getBlacklistDetail({
          StartMonth: this.dayjs(this.monthRange[0]).format("YYYY-MM"),
          EndMonth: this.dayjs(this.monthRange[1]).format("YYYY-MM"),
          Page: this.tableInfo.page,
          PerPage: this.tableInfo.perPage,
        })
        .then((response) => {
          if (response.status === 200) {
            this.tableData = response.data.BlacklistDtos;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 黑名單 圖表
    getBlacklistChart() {
      this.updateLoading(true);
      this.$api.blacklist
        .getBlacklistChart({
          StartMonth: this.dayjs(this.year).format("YYYY-01"),
          EndMonth: this.dayjs(this.year).format("YYYY-12"),
        })
        .then((response) => {
          if (response.status === 200) {
            let arr = [];
            response.data.forEach((item) => {
              arr.push(item.Quantity);
            });
            if (response.data.length < 12) {
              const shortage = 12 - response.data.length;
              let i = 0;
              while (i < shortage) {
                arr.push(0);
                i += 1;
              }
            }
            this.seriesData = arr;
          }
          this.updateLoading(false);
        });
    },

    // 匯出 黑名單（excel）
    exportBlacklist() {
      this.updateLoading(true);
      this.$api.blacklist
        .downloadBlacklist({
          StartMonth: this.dayjs(this.monthRange[0]).format("YYYY-MM"),
          EndMonth: this.dayjs(this.monthRange[1]).format("YYYY-MM"),
        })
        .then((response) => {
          if (response.status === 200) {
            let fileName = decodeURIComponent(
              decodeURIComponent(
                response.headers["content-disposition"].split(
                  "filename*=UTF-8''"
                )[1]
              )
            );
            this.updateLoading(false);
            let blob = new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          }
        });
    },

    // 檢視履歷
    showDetailModal(person) {
      this.ResumeId = person.ResumeId;
      this.isShowDetail = true;
    },

    // el-table 分頁
    handleCurrentChange(currentPage) {
      this.tableInfo.page = currentPage;
      this.getBlacklistDetail();
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    // 黑名單數量
    chartSeries: function () {
      return [
        {
          name: "黑名單數量",
          data: this.seriesData,
        },
      ];
    },
  },

  watch: {
    year: function (newVal) {
      if (newVal) {
        this.getBlacklistChart();
      }
    },
  },

  created() {
    const CURRENT_MONTH = this.dayjs().format("YYYY-MM");
    this.monthRange = [new Date(CURRENT_MONTH), new Date(CURRENT_MONTH)];
    this.year = this.dayjs().format("YYYY");
    this.getBlacklistDetail();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.card-body {
  .chart-title {
    text-align: center;
  }
}
</style>
